import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Field, Option, Spinner } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

// models
import { RelationShipTypeViewModel } from '../../../../models/Entities/Person/RelationshipType/RelationshipTypeModels';
import { PersonTypeEnum } from '../../../../models/Entities/Person/PersonCommands';

// functions
import * as ComponentFunctions from './RelationshipTypeSelector.Functions';

const RelationshipTypeSelectorComponent = (props: ComponentFunctions.Props) => {
  const [t] = useTranslation();

  useEffect(() => {
    props.GetRelationshipTypes();
  }, []);

  const availableTypes = props.relationshipTypes.filter((item: RelationShipTypeViewModel) => {
    if (props.personType === undefined) return true;
    return props.personType === PersonTypeEnum.JuridicalPerson
      ? item.isForLegalPersons
      : item.isForNaturalPersons;
  });

  const selected = availableTypes.find(
    (item: RelationShipTypeViewModel) => item.id === props.selectedRelationshipTypeId
  );

  const handleSelection = (relationshipTypeId: string | undefined) => {
    props.onSelectionChange(relationshipTypeId ? Number(relationshipTypeId) : undefined);
  };

  return (
    <Field
      label={props.label || t('persons.relationshipTypeSelector.label', { defaultValue: 'Tipo de relación' })}
      required={props.isRequired || false}
      validationMessage={props.errorMessage}
      validationState={props.errorMessage ? 'error' : undefined}
    >
      {props.isLoading ? (
        <Spinner size="tiny" />
      ) : (
        <Dropdown
          disabled={props.isDisabled || false}
          placeholder={t('persons.relationshipTypeSelector.placeholder', { defaultValue: 'Seleccione un tipo' })}
          value={selected?.name || ''}
          selectedOptions={selected ? [String(selected.id)] : []}
          onOptionSelect={(_, data) => handleSelection(data.optionValue)}
        >
          {availableTypes.map((item: RelationShipTypeViewModel) => (
            <Option key={item.id} value={String(item.id)} text={item.name || ''}>
              {item.name || ''}
            </Option>
          ))}
        </Dropdown>
      )}
    </Field>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(RelationshipTypeSelectorComponent as any);
